module.exports = __webpack_public_path__ + "img/4.70861a51.webp";